import React from 'react';

const User = (props) => {
    return (
        <div>
            <div className='name-photo flex justify-around'>
                <div>
                    <img className='w-[50px] rounded-full' src={props.user} alt="" />
                </div>
                <div>
                    <h1 className='text-xl font-bold'>Saikut</h1>
                    <h3>Cumilla, Bangladesh</h3>
                </div>
            </div>
            {/* Some info */}
            <div className='flex justify-between shadow-lg rounded-md p-2 bg-slate-50 my-6'>
                <div>
                    <p><span className='details-number'>58</span>kg</p>
                    <p>Weight</p>
                </div>
                <div>
                    <p className='details-number'>5.5</p>
                    <p>Height</p>
                </div>
                <div>
                    <p><span className='details-number'>22</span>yrs</p>
                    <p>Age</p>
                </div>
            </div>
        </div>
    );
};

export default User;